import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { Price } from './Price.es.js';

/**
 * Formats a Price with the given options.
 *
 * If an value needs to be formatted as a commission or saving percentage, use currency.code = '%'.
 * @param {number} value The value to format into a Price
 * @param {Currency} currency The currency to use
 * @param {number} discount The discount to use, must be between 0 and 1
 * @param {Object} options hideCurrencyCode defaulted to true, numberOfDecimals defaulted to 2
 */
var getFormattedPrice = function getFormattedPrice(_ref) {
  var value = _ref.value,
    currency = _ref.currency,
    discount = _ref.discount,
    options = _ref.options;
  var priceBeforeFormat = discount ? value * (1 - discount) : value;
  var price = new Price(_objectSpread({
    value: priceBeforeFormat
  }, currency));
  return price.format(options).formattedPrice;
};

export { getFormattedPrice };
